"use strict";

const IncidentInventoryConstants = function () {
  var getIncidentInventoryDefaults = function (asset = null) {
    const defaults = {
      locationInfo: {},
      generalInfo: {},
      requestingAffiliation: "ms4-staff",
      requestedDate: DateTime.getNowIso(),
    };

    if (asset) {
      defaults.asset = asset;
      defaults.requestingType = "dry-weather-screen";
    }

    return defaults;
  };

  var getRequestingTypeOptions = function () {
    return FormSettings.getDropdownOptions("requesting-type");
  };

  var getRequestingAffiliationOptions = function () {
    return FormSettings.getDropdownOptions("requesting-affiliation");
  };

  var addIncidentToDoFilterOptions = function (props) {
    props.requestingAffiliationOptions = getRequestingAffiliationOptions();
    props.requestingTypeOptions = getRequestingTypeOptions();
    props.incidentTypeOptions = $.extend(
      [],
      IncidentInvestigationConstants.getIncidentTypeOptions(),
    );
    props.incidentTypeOptions.push({ name: "Unknown", value: "unknown" });

    return props;
  };

  return {
    getIncidentInventoryDefaults,
    addIncidentToDoFilterOptions,
    getRequestingTypeOptions,
    getRequestingAffiliationOptions,
  };
};

module.exports = IncidentInventoryConstants();

const IncidentInvestigationConstants = require("../incidentInvestigation/incidentInvestigationConstants");
const FormSettings = require("../../settings/formSettings");
const DateTime = require("../../dateTime");
